var SearchCTA;
(function (SearchCTA) {
    document.addEventListener('ControllerReady', () => {
        const $targets = document.querySelectorAll('.search-cta');
        $targets.forEach(($target) => {
            const $form = $target.querySelector('form');
            const $input = $form.querySelector('input[name="query"]');
            const $geo = $form.querySelector('[data-geo-query]');
            $geo && $geo.addEventListener('click', () => {
                $input.value = 'position';
                $form.submit();
            });
        });
    });
})(SearchCTA || (SearchCTA = {}));
